import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import PostHogProvider from "@/components/PostHogProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
